import { Group, Title } from "@mantine/core";

export default function CardHeader({ title, action }) {
  return (
    <Group mb="sm">
      <Title order={4}>{title}</Title>
      {action}
    </Group>
  );
}
